const BoxIcon: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.92306 1.37867C7.61627 1.11206 8.38373 1.11206 9.07694 1.37867L14.0385 3.28696C14.6178 3.50976 15 4.06632 15 4.68697V11.3134C15 11.934 14.6178 12.4906 14.0385 12.7134L9.07694 14.6217C8.38373 14.8883 7.61627 14.8883 6.92306 14.6217L1.96153 12.7134C1.38224 12.4906 1 11.934 1 11.3134V4.68697C1 4.06632 1.38224 3.50976 1.96153 3.28696L6.92306 1.37867ZM8.71796 2.31202C8.25582 2.13427 7.74418 2.13427 7.28204 2.31202L5.89757 2.84451L11.4885 4.96107L13.4357 4.12655L8.71796 2.31202ZM14 4.9727L8.5 7.32984V13.7581C8.5736 13.7391 8.64637 13.7159 8.71796 13.6883L13.6795 11.78C13.8726 11.7058 14 11.5203 14 11.3134V4.9727ZM7.5 13.7581V7.32984L2 4.9727V11.3134C2 11.5203 2.12741 11.7058 2.32051 11.78L7.28204 13.6883C7.35363 13.7159 7.4264 13.7391 7.5 13.7581ZM2.56425 4.12655L8 6.45616L10.1638 5.52882L4.49652 3.38337L2.56425 4.12655Z"
        fill="#A1A6B2"
      />
    </svg>
  );
};

export default BoxIcon;
